import { render, staticRenderFns } from "./chat-message-item.vue?vue&type=template&id=af944b68&scoped=true&"
import script from "./chat-message-item.vue?vue&type=script&lang=js&"
export * from "./chat-message-item.vue?vue&type=script&lang=js&"
import style0 from "./chat-message-item.vue?vue&type=style&index=0&id=af944b68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af944b68",
  null
  
)

export default component.exports